// Full viewport - full-bleed wrapper for content below top bar

import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';

/**
 * Full-bleed viewport for content.
 * Fills all remaining space below the top bar with no padding or max-width.
 */
class FullViewport extends BaseComponent {
  static styles = css`
    :host {
      display: flex;
      flex: 1;
      overflow: hidden;
      position: relative;
    }

    ::slotted(*) {
      flex: 1;
    }
  `;

  render() {
    return html`<slot></slot>`;
  }
}

customElements.define('full-viewport', FullViewport);
